var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "container mb-4" },
      [
        _c("h2", { staticClass: "k-h-secondary" }, [
          _vm._v("Odpovědi (" + _vm._s(_vm.responsesCount || 0) + ")")
        ]),
        _vm._v(" "),
        _c("discussion-response-form", {
          ref: "commentForm",
          attrs: { url: _vm.submitUrl, method: _vm.submitMethod },
          on: { responseAdded: _vm.getDataAndScroll }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "container mb-3" },
      [
        _c(
          "transition-group",
          { attrs: { name: "list-complete", tag: "div" } },
          [
            _vm._l(_vm.responses, function(response) {
              return [
                _c(
                  "div",
                  {
                    key: response.id,
                    ref: "response-" + response.id,
                    refInFor: true,
                    staticClass: "k-panel k-panel--grid mb-3"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "k-panel__body--3-4 k-border-right" },
                      [
                        _c("div", { staticClass: "k-panel__body " }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(response.content) +
                              "\n                        "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "k-panel__footer justify-content-between align-items-center"
                          },
                          [
                            _c("div", { staticClass: "k-panel__footer-btn" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "k-action mr-3",
                                  attrs: { href: "javascript:;" },
                                  on: {
                                    click: function($event) {
                                      return _vm.$refs.commentForm.reactOnResponse(
                                        response
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        role: "img",
                                        width: "12",
                                        height: "11"
                                      }
                                    },
                                    [
                                      _c("use", {
                                        attrs: {
                                          fill: "currentColor",
                                          "xlink:href":
                                            "/images/spritesheet.svg#reply"
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(
                                    "\n                                    Reagovat\n                                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "k-action",
                                  class: [
                                    {
                                      "k-action--disabled":
                                        response.like_url === null
                                    }
                                  ],
                                  attrs: { href: "javascript:;" },
                                  on: {
                                    click: function($event) {
                                      return _vm.likeResponse(response)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        role: "img",
                                        width: "12",
                                        height: "11"
                                      }
                                    },
                                    [
                                      _c("use", {
                                        attrs: {
                                          fill: "currentColor",
                                          "xlink:href":
                                            "/images/spritesheet.svg#like"
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(
                                    "\n                                    Poděkovat autorovi (" +
                                      _vm._s(response.likes_count) +
                                      ")\n                                "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            response.delete_url !== null
                              ? _c(
                                  "a",
                                  {
                                    staticClass:
                                      "k-action k-action--control-danger k-panel__footer-btn k-panel__footer-btn--no-flex",
                                    attrs: { href: "javascript:;" },
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteResponse(response)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          role: "img",
                                          width: "12",
                                          height: "11"
                                        }
                                      },
                                      [
                                        _c("use", {
                                          attrs: {
                                            fill: "currentColor",
                                            "xlink:href":
                                              "/images/spritesheet.svg#add"
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(
                                      "\n                                Odstranit příspěvek\n                            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "k-panel__body k-panel__body--1-4 border-bottom-0"
                      },
                      [
                        _c("div", { staticClass: "k-user-contact" }, [
                          _c("div", { staticClass: "k-user-contact__image" }, [
                            _c("img", {
                              attrs: { src: response.user.prev_url }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "k-user-contact__meta" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  title: response.user.name,
                                  href: response.user.detail_url
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "k-user-contact__name" },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(response.user.name) +
                                        "\n                                    "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "k-user-contact__date" }, [
                              _vm._v(
                                "\n                                    Vloženo: " +
                                  _vm._s(response.created_at) +
                                  "\n                                "
                              )
                            ])
                          ])
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm._l(response.reactions, function(reaction) {
                  return _c(
                    "div",
                    {
                      key: reaction.id,
                      ref: "response-" + reaction.id,
                      refInFor: true,
                      staticClass:
                        "k-panel k-panel--grid mb-3 k-panel--loffset-1"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "k-panel__body--3-4-fluid k-border-right"
                        },
                        [
                          _c("div", { staticClass: "k-panel__body " }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(reaction.content) +
                                "\n                        "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "k-panel__footer justify-content-between align-items-center"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "k-panel__footer-btn" },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "k-action mr-3",
                                      attrs: { href: "javascript:;" },
                                      on: {
                                        click: function($event) {
                                          return _vm.$refs.commentForm.reactOnResponse(
                                            reaction
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            role: "img",
                                            width: "12",
                                            height: "11"
                                          }
                                        },
                                        [
                                          _c("use", {
                                            attrs: {
                                              fill: "currentColor",
                                              "xlink:href":
                                                "/images/spritesheet.svg#reply"
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(
                                        "\n                                    Reagovat\n                                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "k-action",
                                      class: [
                                        {
                                          "k-action--disabled":
                                            reaction.like_url === null
                                        }
                                      ],
                                      attrs: { href: "javascript:;" },
                                      on: {
                                        click: function($event) {
                                          return _vm.likeResponse(reaction)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            role: "img",
                                            width: "12",
                                            height: "11"
                                          }
                                        },
                                        [
                                          _c("use", {
                                            attrs: {
                                              fill: "currentColor",
                                              "xlink:href":
                                                "/images/spritesheet.svg#like"
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(
                                        "\n                                    Poděkovat autorovi (" +
                                          _vm._s(reaction.likes_count) +
                                          ")\n                                "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              reaction.delete_url !== null
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "k-action k-action--control-danger k-panel__footer-btn k-panel__footer-btn--no-flex",
                                      attrs: { href: "javascript:;" },
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteResponse(reaction)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            role: "img",
                                            width: "12",
                                            height: "11"
                                          }
                                        },
                                        [
                                          _c("use", {
                                            attrs: {
                                              fill: "currentColor",
                                              "xlink:href":
                                                "/images/spritesheet.svg#add"
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(
                                        "\n                                Odstranit příspěvek\n                            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "k-panel__body k-panel__body--1-4-fix border-bottom-0"
                        },
                        [
                          _c("div", { staticClass: "k-user-contact" }, [
                            _c(
                              "div",
                              { staticClass: "k-user-contact__image" },
                              [
                                _c("img", {
                                  attrs: {
                                    src: reaction.user.prev_url,
                                    alt: ""
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "k-user-contact__meta" }, [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    title: reaction.user.name,
                                    href: reaction.user.detail_url
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "k-user-contact__name" },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(reaction.user.name) +
                                          "\n                                    "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "k-user-contact__date" },
                                [
                                  _vm._v(
                                    "\n                                    Vloženo: " +
                                      _vm._s(reaction.created_at) +
                                      "\n                                "
                                  )
                                ]
                              )
                            ])
                          ])
                        ]
                      )
                    ]
                  )
                })
              ]
            })
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }